'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '0 0 1024 1024' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M192 0h128v256c0 35.346-28.654 64-64 64h-256v-128h192v-192z' }),
        React.createElement('path', { d: 'M704 0h128v192h192v128h-256c-35.346 0-64-28.654-64-64v-256z' }),
        React.createElement('path', { d: 'M768 704h256v128h-192v192h-128v-256c0-35.346 28.654-64 64-64z' }),
        React.createElement('path', { d: 'M0 704h256c35.346 0 64 28.654 64 64v256h-128v-192h-192v-128z' })
    ));
};